import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  IconButton,
  Typography,
  Alert,
  AlertTitle,
  CircularProgress,
} from "@mui/material";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import { Facebook, Google, Twitter } from "@mui/icons-material";
import Div from "@jumbo/shared/Div";
import { alpha } from "@mui/material/styles";
import { ASSET_IMAGES } from "app/utils/constants/paths";
import { getAssetPath } from "app/utils/appHelpers";
import * as yup from "yup";
import { Form, Formik } from "formik";
import JumboTextField from "@jumbo/components/JumboFormik/JumboTextField";
import LoadingButton from "@mui/lab/LoadingButton";
import authServices from "app/services/auth-services";
import { useNavigate } from "react-router-dom";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import { setAuthToken } from "@jumbo/services/auth/jwtAuth";
import { dispatch } from "app/store/store";
import { signInThunk } from "app/store/slice/login-slice";
import SweetAlert from "app/Common/SweetAlert";
import { unwrapResult } from "@reduxjs/toolkit";

const validationSchema = yup.object({
  username: yup.string("Enter your username").required("Username is required"),
  password: yup.string("Enter your password").required("Password is required"),
});

const Login = ({ disableSmLogin }) => {
  // const [isValid, setIsValid] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [isSingleSignOn, setIsSingleSignOn] = useState(false);
  const ToastRef = useRef();
  //const { setAuthToken } = useJumboAuth();
  const navigate = useNavigate();
  const currentDomain = window.location.hostname;

  const onSignIn = (username, password, sscode) => {
    setSubmitting(true);

    dispatch(
      signInThunk({ username: username, password: password, sscode: sscode })
    )
      .then(unwrapResult)
      .then((res) => {
        if (res.data.success == true) {
          let resultData = res.data;
          setAuthToken(resultData?.access_token);
          //navigate("/home/dashboard", { replace: true });
          window.location.href = "/home/dashboard";
        } else {
          setSubmitting(false);
          ToastRef.current.showSweetAlerts("error", res.data.message);
        }
      });
  };

  useEffect(() => {
    const currentPathName = window.location.pathname;
    if (currentPathName != "") {
      let urlParamsArr = currentPathName.split("/");

      if (
        urlParamsArr.length == 3 &&
        urlParamsArr[1] == "login" &&
        urlParamsArr[2] != ""
      ) {
        setIsSingleSignOn(true);
        console.log("coming here");
      }
    }
  }, []);

  useEffect(() => {
    if (isSingleSignOn == true) {
      const currentPathName = window.location.pathname;
      let urlParamsArr = currentPathName.split("/");
      if (
        urlParamsArr.length == 3 &&
        urlParamsArr[1] == "login" &&
        urlParamsArr[2] != ""
      ) {
        onSignIn("", "", urlParamsArr[2]);
      }
    }
  }, [isSingleSignOn]);

  let loginBackgroundImage = "";
  if (currentDomain.indexOf("adfuel.us") != -1) {
    loginBackgroundImage = ASSET_IMAGES + "/Login_Background_adfuel.png";
  } else if (currentDomain.indexOf("contextnetworks.net") != -1) {
    loginBackgroundImage = ASSET_IMAGES + "/Login_Background_context.png";
  } else if (currentDomain.indexOf("savvydsp.com") != -1) {
    loginBackgroundImage = ASSET_IMAGES + "/savvy_media.png";
  } else if (currentDomain.indexOf("perfectaudience.io") != -1) {
      loginBackgroundImage = ASSET_IMAGES + "/Perfect_Audience.png";
  } else if (currentDomain.indexOf("arrowmarketinglabs.com") != -1) {
      loginBackgroundImage = ASSET_IMAGES + "/arrow_marketing.png";
  } else {
    loginBackgroundImage = ASSET_IMAGES + "/Login_Background.jpg";
  }

  return (
    <>
      {isSingleSignOn == true && (
        <Div
          sx={{
            width: 720,
            maxWidth: "100%",
            margin: "auto",
            p: 4,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress
              sx={{
                zIndex: 4,
                position: "absolute",
                top: "50%",
                width: "70px !important",
                height: "70px !important",
                //left: "50%",
                transform: "translate(-50%, -50%)",
                transform: "-webkit-translate(-50%, -50%)",
                transform: "-moz-translate(-50%, -50%)",
                transform: "-ms-translate(-50%, -50%)",
              }}
            />
          </Box>
          <SweetAlert ref={ToastRef} />
        </Div>
      )}
      {isSingleSignOn == false && (
        <Div
          sx={{
            width: 720,
            maxWidth: "100%",
            margin: "auto",
            p: 4,
          }}
        >
          <Card
            sx={{
              display: "flex",
              minWidth: 0,
              flexDirection: { xs: "column", md: "row" },
            }}
          >
            <CardContent
              sx={{
                flex: "0 1 300px",
                position: "relative",
                background: `${
                  currentDomain.indexOf("contextnetworks.net") != -1
                    ? "#000"
                    : currentDomain.indexOf("savvydsp.com") != -1
                    ? "#ffffff"
                    : currentDomain.indexOf("arrowmarketinglabs.com") != -1
                    ? "#ffffff"
                    : currentDomain.indexOf("perfectaudience.io") != -1
                    ? "#ffffff"
                    : "#0267a0"
                } url(${getAssetPath(
                  loginBackgroundImage,
                  "640x428"
                )}) no-repeat center`,
                backgroundSize:
                  currentDomain.indexOf("contextnetworks.net") != -1 ||
                  currentDomain.indexOf("savvydsp.com") != -1 ||
                  currentDomain.indexOf("arrowmarketinglabs.com") != -1 ||
                  currentDomain.indexOf("perfectaudience.io") != -1
                    ? "contain"
                    : "cover",

                "&::after": {
                  display: "inline-block",
                  position: "absolute",
                  content: `''`,
                  inset: 0,
                  backgroundColor:
                    currentDomain.indexOf("adfuel.us") != -1 ||
                    currentDomain.indexOf("contextnetworks.net") != -1 ||
                    currentDomain.indexOf("savvydsp.com") != -1 ||
                    currentDomain.indexOf("arrowmarketinglabs.com") != -1 ||
                    currentDomain.indexOf("perfectaudience.io") != -1
                      ? "transparent"
                      : alpha("#0267a0", 0.65),
                },
              }}
            >
              <Div
                sx={{
                  display: "flex",
                  minWidth: 0,
                  flex: 1,
                  flexDirection: "column",
                  color: "common.white",
                  position: "relative",
                  zIndex: 1,
                  height: "100%",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Div
                  sx={{
                    display:
                      currentDomain.indexOf("advangelists.com") != -1
                        ? ""
                        : "none",
                  }}
                >
                  <Link
                    href="#"
                    underline="none"
                    sx={{ display: "inline-flex" }}
                  >
                    <img
                      //src={`${ASSET_IMAGES}/mob-network-logo.png`}
                      src={`${ASSET_IMAGES}/newlogo_white.png`}
                      alt="Mobiquity React"
                      height="50px"
                    />
                  </Link>
                </Div>
              </Div>
            </CardContent>
            <CardContent sx={{ flex: 1, p: 4 }}>
              <Formik
                validateOnChange={true}
                initialValues={{
                  username: "",
                  password: "",
                }}
                validationSchema={validationSchema}
                onSubmit={(data) => {
                  onSignIn(data.username, data.password);
                }}
              >
                {(props) => (
                  <Form
                    style={{ textAlign: "left" }}
                    noValidate
                    autoComplete="off"
                    onSubmit={props.handleSubmit}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        props.handleSubmit();
                      }
                    }}
                  >
                    <Div sx={{ mt: 1, mb: 3 }}>
                      <JumboTextField
                        fullWidth
                        name="username"
                        label="Username"
                        autoComplete="off"
                      />
                    </Div>
                    <Div sx={{ mt: 1, mb: 2 }}>
                      <JumboTextField
                        fullWidth
                        name="password"
                        label="Password"
                        type="password"
                      />
                    </Div>
                    <Div sx={{ mb: 2 }}>
                      <FormControlLabel
                        control={<Checkbox />}
                        label="Remember me"
                      />
                    </Div>
                    <LoadingButton
                      fullWidth
                      type="submit"
                      variant="contained"
                      size="large"
                      sx={{ mb: 3 }}
                      loading={submitting}
                    >
                      Sign In
                    </LoadingButton>

                    <Box sx={{ justifyContent: "center" }}>
                      <center>
                        <Link href="/forgotpassword" sx={{ cursor: "pointer" }}>
                          {" "}
                          Forgot Password?
                        </Link>
                      </center>
                    </Box>
                  </Form>
                )}
              </Formik>
            </CardContent>
          </Card>
          <SweetAlert ref={ToastRef} />
        </Div>
      )}
    </>
  );
};

export default Login;
